<template src="./InputRangeComponent.html"></template>

<script>
import IconEyeSlash from '@/components/icons/IconEyeSlash.vue'
import IconEye from '@/components/icons/IconEye.vue'

export default {
  name: 'InputRangeComponent',
  components: { IconEye, IconEyeSlash },
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: () => false
    },
    id: {
      type: String,
      required: true
    },
    min: {
      type: Number,
      required: true
    },
    max: {
      type: Number,
      required: true
    },
    step: {
      type: Number,
      required: true
    },
    label: {
      type: String,
      required: false,
      default: () => ''
    },
    valueDefault: {
      type: Number,
      required: false,
      default: () => 0
    }
  },
  created() {
    if (this.valueDefault) {
      this.value = this.valueDefault
    }
  },
  data() {
    return {
      value: 0,
    }
  },
  watch: {
    value() {
      this.$emit('inputValue', this.value)
    },
    valueDefault() {
      this.value = this.valueDefault
    }
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
.slider {
  -webkit-appearance: none;
  width: 100%;
  height: 20px;
  background: #d3d3d3;
  outline: none;
  opacity: 0.7;
  border-radius: 20px;
  -webkit-transition: .2s;
  transition: opacity .2s;
}

.slider:hover {
  opacity: 1;
}

.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #04AA6D;
  cursor: pointer;
}

.slider::-moz-range-thumb {
  width: 15px;
  height: 15px;
  background: #04AA6D;
  cursor: pointer;
}
</style>
